import React, { useEffect, useState } from "react";
import Header from "../pages/header";
import { CustomeStyle } from "../Css/CustomeStyle";
import { FaTrashAlt } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { deleteWishList, GetWishList } from "../redux/slices/GetWishList";
import { AddToCart } from "../redux/slices/AddTocartSlice";
import { toast } from "react-toastify";
import Footer from "../Fotter";
import { Link } from "react-router-dom";
import { viewCartData } from "../redux/slices/ViewCartSlice";
import { FaShoppingCart } from "react-icons/fa";

const Wishlist = () => {
  const dispatch = useDispatch();
  const { GetWishListData } = useSelector((state) => state.getWishlistData);
  const { ViewCart } = useSelector((state) => state.viewCart);
  const [isInCart, setIsInCart] = useState({});

  useEffect(() => {
    if (Array.isArray(ViewCart?.cart)) {
      const newCartState = {};
      ViewCart.cart.forEach((cartItem) => {
        newCartState[cartItem?.productId] = true;
      });
      setIsInCart(newCartState);
    }
  }, [ViewCart]);

  useEffect(() => {
    dispatch(GetWishList());
    dispatch(viewCartData());
  }, [dispatch]);

  const handleRemove = (id) => {
    dispatch(deleteWishList(id));
  };

  const handleAddToCart = (item) => {
    const cartData = {
      productId: item?.productId,
      quantity: 1,
    };
    dispatch(AddToCart(cartData)).then((result) => {
      if (result.meta.requestStatus === "fulfilled") {
        dispatch(viewCartData());
        toast.success("Product added to cart!", {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        });
      } else {
        console.log("Responce Error");
      }
    });
  };

  const generateSlug = (text) => {
    if (!text) {
      return "";
    }
    return text
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />
      <div className="flex flex-col">
        <main className={CustomeStyle.container}>
          <h1 className="text-2xl font-semibold mb-6">
            My Wishlist{" "}
            {GetWishListData?.wishlist?.length > 0 &&
              `(${GetWishListData?.wishlist?.length})`}
          </h1>
          <div className="flex flex-col md:grid gap-6 overflow-x-auto ">
            {GetWishListData?.wishlist?.length > 0 ? (
              GetWishListData?.wishlist?.map((item, index) => (
                <div
                  key={item.index}
                  className="border rounded-lg shadow-md p-6 bg-white flex flex-col md:flex-row items-center md:items-start relative hover:shadow-lg transition duration-300"
                >
                  <button
                    onClick={() => handleRemove(item.productId)}
                    className="absolute top-3 right-3 text-gray-500 hover:text-red-800 "
                  >
                    <FaTrashAlt size={20} />
                  </button>
                  <Link
                    to={`/shop/${generateSlug(item?.category)}/${generateSlug(
                      item?.subcategory
                    )}/${generateSlug(item?.title)}`}
                    state={{ item }}
                    className=" flex flex-col md:flex-row items-center md:items-start relative  transition duration-300"
                    key={item.productId}
                  >
                    <img
                      src={item.productImage}
                      alt={item.name}
                      className="w-32 h-40 object-cover mb-4 md:mb-0 md:mr-4 rounded-md "
                    />
                    <div className="flex flex-col items-center md:items-start ml-12 ">
                      <h3 className="text-lg font-semibold text-gray-800 mb-2">
                        {item?.title}
                      </h3>
                      <p className="text-sm text-gray-600 flex items-center mb-2">
                        <span className={CustomeStyle.smalltext}>Category</span>{" "}
                        : {item.category}
                      </p>
                      <div className="flex flex-row items-center gap-2 mb-2">
                        <p className="text-sm text-gray-600 flex items-center">
                          <span className={CustomeStyle.smalltext}>Price</span>{" "}
                          : ₹{item.salePrice}
                        </p>
                        <p className="text-sm text-gray-400 line-through">
                          ₹{item.price}
                        </p>
                      </div>
                      <p className="text-sm text-gray-600 mb-2 line-clamp-3">
                        <span className={CustomeStyle.smalltext}>
                          Description
                        </span>
                        : {item.description}
                      </p>
                      <p className="text-sm text-gray-600 mb-2">
                        <span className={CustomeStyle.smalltext}>Brand</span>:{" "}
                        {item.brand}
                      </p>
                      <p className="text-sm text-gray-600 mb-2">
                        <span className={CustomeStyle.smalltext}>Rating</span>:{" "}
                        {item.rating}⭐
                      </p>
                    </div>
                  </Link>
                  <div className="flex w-full items-end justify-end self-end mt-4 md:mt-0">
                    <button
                      onClick={() => handleAddToCart(item)}
                      className="bg-blue-600 text-white md:px-2 px-3 md:py-2 py-3 rounded-md hover:bg-blue-700 w-full md:w-auto flex gap-2 justify-center"
                    >
                      <FaShoppingCart size={20} />
                      {isInCart[item?.productId]
                        ? "Added to Cart"
                        : "Add to Cart"}
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center text-black p-10 ">
                Your wishlist is empty. Start adding your favorite items!
              </div>
            )}
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Wishlist;
